module.exports = __webpack_public_path__ + "media/src/images/lady-in-cafe-p-500x281-7916b516a4e92578fb6ba5d9482b3aae.jpeg";